import 'bootstrap/dist/css/bootstrap.min.css'; 
import books from '../assets/img/books.gif'
import '../assets/css/EduSection.css'
import Roll from 'react-reveal/Roll';

function EduSection() {
    return (
        <div className="sec7 container">
            
            <div>
            <h2>Education</h2>
            <Roll left>
            <div className="row eduSec">
                <div className="col imgedu">
                    <img src={books} alt="line" />
              </div>
              <div className="col edurows">
                <div className='row edurow row1'>
                    <h2><b>AIKTC</b></h2>
                    <h2 className='year'>2016-2020</h2>
                    <h2>Computer Engineering</h2>
                    <h2>CGPI - <b>8.14</b></h2>
                </div>
                <div className='row edurow row2'>
                    <h2><b>DRT. Junior College</b></h2>
                    <h2 className='year'>2015-2016</h2>
                    <h2>HSC</h2>
                    <h2>Percentage - <b>60.92 %</b></h2>
                </div>
                <div className='row edurow row3'>
                    <h2><b>ABHS</b></h2>
                    <h2 className='year'>2013-2014</h2>
                    <h2>SSC</h2>
                    <h2>Percentage - <b>83.20 %</b></h2>
                </div>
              </div>
              
            </div>
            </Roll>
            </div>
           
          </div>
        );
    }
    
export default EduSection;